module.exports = __webpack_public_path__ + "static/media/my-portfolio.ebef4d83.png";